import {FC} from "react";
import {OrderType} from "../../../bll/types";
import {CURRENCY} from "../../../common/utils/constants/constants";

type OrderPropsType = {
    order: OrderType
}
export const Order: FC<OrderPropsType> = ({order}) => {
    return (
        <div>
            <span>{order.id + " "}</span>
            <span>{order.createdAt + " "}</span>
            <span>{order.totalPrice + " " + CURRENCY}</span>
        </div>
    )
}